import React, { useState, useEffect } from 'react';

const DateTimeDisplay = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    // Update time every second
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    // Cleanup timer on unmount
    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return date.toLocaleDateString('en-US', options);
  };

  const formatTime = (date) => {
    const options = {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    };
    return date.toLocaleTimeString('en-US', options);
  };

  return (
    <div className="text-right">
      <div className="text-sm text-gray-600 font-medium">
        {formatDate(currentTime)}
      </div>
      <div className="text-lg font-bold text-gray-800">
        {formatTime(currentTime)}
      </div>
    </div>
  );
};

export default DateTimeDisplay;



